module.exports = __webpack_public_path__ + "img/issue.85125a9e.png";